export default {
  getHead: () => {
    return [{ name: '사업장명' }, { name: '종사자 부서' }, { name: '종사자 성명' }, { name: '직종' }, { name: '작성자' }, { name: '작성일' }]
  },
  getCol: (index, value, func) => {
    try {
      switch (index) {
      case 0: return func.getContent(value).stdInfo.field_name  // 사업장명
      case 1: return func.getContent(value).companyName         // 종사자 부서
      case 2: return func.getContent(value).inputB_4            // 종사자 성명
      case 3: return func.getContent(value).inputB_7            // 직종
      case 4: return func.getContent(value).stdInfo.writer_name // 작성자
      case 5: return func.getCreatedDate(value.created_at) // 작성일
      }
    } catch (e) { /*ignore*/ }
    return ''
  },
  getSearchKeyValue: (nav) => {
    if (nav.value.created_at) {
      nav.dateTarget = 'created_at'
      nav.dateBegin = 'nav.value.created_at.sDate'
      nav.dateEnd = 'nav.value.created_at.eDate'
    }
    return { searchType: nav.value.searchType, searchKeyword: nav.value.searchKeyword }
  },
  getSearchKeyword: (nav) => {
    const returnData = []

    switch (nav.value.searchType) {
    case '사업장명': returnData.push('content$body.stdInfo.writer_name*%[:default_skw]%'); break
    case '종사자 부서': returnData.push('content$body.companyName*%[:default_skw]%'); break
    case '종사자 성명': returnData.push('content$body.inputB_4*%[:default_skw]%'); break
    case '직종': returnData.push('content$body.inputB_7*%[:default_skw]%'); break
    case '작성자': returnData.push('content$body.stdInfo.writer_name*%[:default_skw]%'); break
    }
    return returnData
  },
}
